import { PureComponent } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import VerifyStep from './VerifyStep';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class OpenFacebookRow extends PureComponent {
  renderButton() {
    const {
      pageLink
    } = this.props;
    return /*#__PURE__*/_jsx(Button, {
      use: "tertiary",
      size: "small",
      href: pageLink,
      external: true,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "MessagesApp.verifyFbmPrompt.stepOne.button"
      })
    });
  }
  render() {
    return /*#__PURE__*/_jsx(VerifyStep, {
      button: this.renderButton(),
      children: /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(Text, {
          as: "h5",
          marginBlockEnd: "200",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "MessagesApp.verifyFbmPrompt.stepOne.header"
          })
        }), /*#__PURE__*/_jsx(Text, {
          marginBlockEnd: "0",
          as: "p",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "MessagesApp.verifyFbmPrompt.stepOne.body"
          })
        })]
      })
    });
  }
}
OpenFacebookRow.displayName = 'OpenFacebookRow';
export default OpenFacebookRow;